import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// W-2 year-end income/tax summary (Point 18). Derived from saved paychecks;
// there is no separately stored/edited W-2 record.
const W2Service = {
  // HR/Admin: one employee's year summary.
  getEmployeeSummary: async (employeeId, year) => {
    const response = await axiosInstance.get(API.w2.getByEmployee(employeeId, year));
    return response.data;
  },

  // Employee: my own year summary (read-only).
  getMySummary: async (year) => {
    const response = await axiosInstance.get(API.w2.me(year));
    return response.data;
  },
};

export default W2Service;
